import {IPaylodAction, IActionDispatcher, IExportMapDispatcher} from '../../interfaces/dispatchers'
import MapActions from '../../enums/ActionTypes/MapActions'
import {IStore} from '../../interfaces/reducers'
import {IFeatureLayerInfo} from '../../interfaces/models'
import {IMapClickParams, IMapPopupProperties} from '../../interfaces/models'

import {OnClickAction} from '../../enums/MapEvents'

import {IMapDispatcher} from '../../interfaces/dispatchers'
import {Geometry, Feature, Extent, VectorSource, Point} from '../../models'
import {IMapService} from '../../interfaces/services'
import ExportMapActions from '../../enums/ActionTypes/ExportMapActions'
import {DrawSource} from '../../enums/DrawSource'
import {ServiceHub} from '../../ServiceHub'

export class MapDispatcher implements IMapDispatcher {
  exportMapDispatcher: IExportMapDispatcher
  constructor(exportMapDispatcher: IExportMapDispatcher) {
    this.exportMapDispatcher = exportMapDispatcher
    this.setMapOnClick = this.setMapOnClick.bind(this)
    this.extentChanged = this.extentChanged.bind(this)
    this.addMapManager = this.addMapManager.bind(this)
    this.onMapClick = this.onMapClick.bind(this)
    this.setPopupProperties = this.setPopupProperties.bind(this)
    this.setBasemap = this.setBasemap.bind(this)
    this.setHardLoading = this.setHardLoading.bind(this)
  }

  public identifyToTables(geometry: Geometry) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {}
  }

  public coordinatesToBBOX(coordinates: [number, number], mapService: IMapService, factor?: number): Extent {
    factor = factor ? factor : 1
    const dist = 3145728 / (Math.pow(2, mapService.getZoom()) * factor) / 2
    return new Extent([coordinates[0] - dist, coordinates[1] - dist, coordinates[0] + dist, coordinates[1] + dist])
  }

  public setHardLoading(loading: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      dispatch({
        type: MapActions.SET_HARD_LOADING,
        payload: loading
      })
    }
  }

  public setPopupProperties(popupProperties: IMapPopupProperties) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const mapStore = getStore().map
      const mapService = mapStore.mapService
      const currentFeatures = mapStore.popup.data
      if (currentFeatures) {
        mapService.drawing.unMark(
          DrawSource.Select,
          currentFeatures.map(g => g.feature)
        )
      }

      if (popupProperties.show && popupProperties.data && popupProperties.data.length > 0) {
        let feature = popupProperties.data[0].feature
        if (popupProperties.selectedPage) {
          feature = popupProperties.data[popupProperties.selectedPage].feature
        }
        mapService.drawing.mark([feature], DrawSource.Select)
      }
      if (popupProperties.maximized != mapStore.popup.maximized) {
        setTimeout(() => {
          mapService.updateSize()
          if (popupProperties.maximized == false) {
            setTimeout(() => {
              dispatch({
                type: MapActions.SET_POPUP_PROPERTIES,
                payload: popupProperties
              })
            }, 100)
          }
        }, 100)
      }
      dispatch({
        type: MapActions.SET_POPUP_PROPERTIES,
        payload: popupProperties
      })
    }
  }

  protected onMapClickBefore(
    store: IStore,
    dispatch: (data: any) => void,
    clickParams: IMapClickParams
  ): Array<IFeatureLayerInfo> {
    const featureLayerInfosToIdent: Array<IFeatureLayerInfo> = []
    const layerInfos = store.layerInfos.featureLayerInfos
    for (const i in layerInfos) {
      const layer = layerInfos[i].getLayer(store.map.zoom)

      if (layer && layer.getVisible() && !layerInfos[i].sourceDescription.doNotIdentify) {
        featureLayerInfosToIdent.push(layerInfos[i])
      }
    }
    switch (store.map.onClickAction) {
      case OnClickAction.IdentifyToTables:
        // dispatch(featureTableDispatcher.setSyncFeatureTables(featurePayload))
        break
      case OnClickAction.Popup:
        if (featureLayerInfosToIdent.length > 0) {
          const featureMap: Array<{id: string; feature: Feature}> = []
          if (!store.application.mobile) {
            dispatch(
              this.setPopupProperties({
                show: true,
                coordinates: clickParams.mapPoint.getCoordinates() as [number, number],
                maximized: store.map.popup.maximized,
                data: featureMap,
                selectedPage: 0,
                loading: true
              })
            )
          }
        }
        break
      default:
        break
    }

    return featureLayerInfosToIdent
  }

  protected onMapClickAfter(
    store: IStore,
    dispatch: (data: any) => void,
    clickParams: IMapClickParams,
    results: {layerInfo: IFeatureLayerInfo; features: Feature[]}[]
  ) {
    const featurePayload: {[id: string]: Array<Feature>} = {}
    results.forEach(r => {
      featurePayload[r.layerInfo.url] = r.features
    })
    switch (store.map.onClickAction) {
      case OnClickAction.IdentifyToTables:
        // dispatch(featureTableDispatcher.setSyncFeatureTables(featurePayload))
        break
      case OnClickAction.Popup:
        const featureMap: Array<{id: string; feature: Feature}> = []
        for (const id in featurePayload) {
          featurePayload[id].forEach(g => {
            featureMap.push({id: id, feature: g})
          })
        }
        if (store.application.mobile) {
          if (featureMap.length > 0) {
            setTimeout(() => {
              const pointCoordinates = featureMap[0].feature.getGeometry().getCenter().getCoordinates()
              const mapExtent = store.map.mapService.getExtent()
              const x = pointCoordinates[0]
              const y = pointCoordinates[1] // - ((mapExtent.getHeight()) / 10) * 4;
              store.map.mapService.animateTo(new Point([x, y])).then(r => {
                dispatch(
                  this.setPopupProperties({
                    show: featureMap.length > 0,
                    coordinates: pointCoordinates as [number, number],
                    maximized: store.map.popup.maximized,
                    data: featureMap,
                    selectedPage: 0,
                    loading: false
                  })
                )
              })
            }, 100)
          } else {
            dispatch(
              this.setPopupProperties({
                show: false,
                coordinates: clickParams.mapPoint.getCoordinates() as [number, number],
                maximized: store.map.popup.maximized,
                data: [],
                selectedPage: 0,
                loading: false
              })
            )
          }
        } else {
          dispatch(
            this.setPopupProperties({
              show: featureMap.length > 0,
              coordinates: clickParams.mapPoint.getCoordinates() as [number, number],
              maximized: store.map.popup.maximized,
              data: featureMap,
              selectedPage: 0,
              loading: false
            })
          )
        }

        break
      default:
        break
    }
  }

  protected onMapClickError(store: IStore, dispatch: (data: any) => void, clickParams: IMapClickParams, e: Error) {
    switch (store.map.onClickAction) {
      case OnClickAction.IdentifyToTables:
        // dispatch(featureTableDispatcher.setSyncFeatureTables(featurePayload))
        break
      case OnClickAction.Popup:
        const featureMap: Array<{id: string; feature: Feature}> = []
        dispatch(
          this.setPopupProperties({
            show: true,
            coordinates: clickParams.mapPoint.getCoordinates() as [number, number],
            maximized: store.map.popup.maximized,
            data: featureMap,
            selectedPage: 0,
            loading: false,
            error: e
          })
        )

        break
      default:
        break
    }
  }

  public onMapClick(clickParams: IMapClickParams) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      const mapService = store.map.mapService
      if (store.map.onClickDisabled) {
        return
      }
      const featureLayerInfosToIdent = this.onMapClickBefore(store, dispatch, clickParams)
      ServiceHub.gisCrudService
        .identify(
          featureLayerInfosToIdent,
          this.coordinatesToBBOX(clickParams.mapPoint.getCoordinates() as [number, number], mapService)
        )
        .then(results => {
          this.onMapClickAfter(store, dispatch, clickParams, results)
        })
        .catch(e => {
          this.onMapClickError(store, dispatch, clickParams, e)
        })
    }
  }

  public setMapOnClick(onClickAction: OnClickAction) {
    return (dispatch: (data: IPaylodAction) => void) => {
      dispatch({
        type: MapActions.CHANGE_ONCLICK_ACTION,
        payload: onClickAction
      })
      dispatch({
        type: ExportMapActions.SET_FEATURES,
        payload: undefined
      })
    }
  }
  extentChangedTimeout: ReturnType<typeof setTimeout>
  public extentChanged(extent: number[], zoom: number, centerX: number, centerY: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const intZoom = parseInt(zoom.toFixed(0))
      const ext = new Extent(extent)
      dispatch({
        type: MapActions.EXTENT_CHANGED,
        payload: {extent: ext, zoom: intZoom, centerX, centerY}
      })
      if (this.extentChangedTimeout) {
        clearTimeout(this.extentChangedTimeout)
      }

      this.extentChangedTimeout = setTimeout(() => {
        const store = getStore()
        dispatch(this.exportMapDispatcher.setExtent(ext))
        const layers = store.map.mapService.getLayers()
        layers.forEach(l => {
          if (l.moreInfo.refreshOnExtentChange && l.getSource() instanceof VectorSource) {
            l.refresh()
          }
        })
      }, 150)
    }
  }

  public addMapManager(mapService: IMapService) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      dispatch(this.exportMapDispatcher.setExtent(mapService.getExtent()))
      dispatch({
        type: MapActions.ADD_MAP_MANAGER,
        payload: mapService
      })
    }
  }

  public setBasemap(basemap: string) {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      const mapStore = getStore().map
      mapStore.mapService.setBasemap(basemap)

      dispatch({
        type: MapActions.SET_BASEMAP,
        payload: basemap
      })
    }
  }
}
